import { Eye, EyeOff } from 'lucide-react';
import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Giriş / şifre değiştir sayfaları için şifre alanı (göster / gizle).
 * @param {{
 *   id?: string,
 *   name?: string,
 *   label: string,
 *   value: string,
 *   onChange: (e: import('react').ChangeEvent<HTMLInputElement>) => void,
 *   autoComplete?: string,
 *   disabled?: boolean,
 *   required?: boolean,
 *   className?: string,
 * }} props
 */
export function PasswordField({
    id: idProp,
    name,
    label,
    value,
    onChange,
    autoComplete = 'current-password',
    disabled = false,
    required = true,
    className = 'mb-4',
}) {
    const { t } = useTranslation();
    const fallbackId = useId();
    const id = idProp ?? fallbackId;
    const [visible, setVisible] = useState(false);

    return (
        <div className={className}>
            <label htmlFor={id} className="form-label login-field-label">
                {label}
            </label>
            <div className="login-password-wrap">
                <input
                    id={id}
                    type={visible ? 'text' : 'password'}
                    name={name}
                    className="form-control login-field-input login-password-input"
                    autoComplete={autoComplete}
                    value={value}
                    onChange={onChange}
                    required={required}
                    disabled={disabled}
                />
                <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setVisible((v) => !v)}
                    disabled={disabled}
                    aria-label={
                        visible
                            ? t('passwordField.hide')
                            : t('passwordField.show')
                    }
                    aria-pressed={visible}
                >
                    {visible ? (
                        <EyeOff size={18} strokeWidth={1.85} aria-hidden />
                    ) : (
                        <Eye size={18} strokeWidth={1.85} aria-hidden />
                    )}
                </button>
            </div>
        </div>
    );
}
